var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1509_1614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4025 21.7294V21.7269C22.265 21.7369 21.5562 21.7794 19.975 21.7794C18.7125 21.7794 17.8237 21.7419 17.5112 21.7269V21.7307C12.6512 21.5169 9.02375 20.6707 9.02375 19.6582C9.02375 18.6469 12.6512 17.8007 17.5112 17.5832V20.8882C17.8287 20.9107 18.7387 20.9644 19.9962 20.9644C21.505 20.9644 22.2613 20.9019 22.4025 20.8894V17.5857C27.2525 17.8019 30.8713 18.6482 30.8713 19.6582C30.8713 20.6707 27.2525 21.5144 22.4025 21.7294ZM22.4025 17.2419V14.2844H29.17V9.77441H10.7438V14.2844H17.5112V17.2407C12.0112 17.4932 7.875 18.5832 7.875 19.8882C7.875 21.1932 12.0112 22.2819 17.5112 22.5357V32.0132H22.4025V22.5332C27.8938 22.2807 32.02 21.1919 32.02 19.8882C32.02 18.5844 27.8938 17.4957 22.4025 17.2419Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_1614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.1bbdc9070250fddeb54e275f105b2e67.svg";
export { ForwardRef as ReactComponent };